import { Box, Button, Card, CardActions } from "@mui/material";
import ValueGroupReferencePagePicker from "./ValueGroupReferencePagePicker";
import { FieldValueGroupReference } from "generated/graphql";
import { StateHandle } from "StateHandle";
import { useAppSelector } from "redux/hooks";
import { selectIntakes } from "redux/slices/case";

export interface FieldValueGroupReferenceRangeEditorProps {
  reference: FieldValueGroupReference;
  onUpdate: () => void;
  onDelete: (referenceId: number) => void;
  dataPendo: string | undefined;
  pageRangeState: StateHandle<[number, number] | undefined>;
  referenceTypeState: StateHandle<"page" | "page_range">;
  referenceUpdated: boolean;
}

export function FieldValueGroupReferenceRangeEditor({
  reference,
  onUpdate,
  onDelete,
  dataPendo,
  pageRangeState,
  referenceTypeState,
  referenceUpdated,
}: FieldValueGroupReferenceRangeEditorProps) {
  const intakes = useAppSelector(selectIntakes);
  const intake = intakes.find((i) => i.id === reference.documentIntakeId);
  return (
    <Card variant="outlined" sx={{ mt: 1 }}>
      <Box sx={{ p: 1 }}>
        {intake && (
          <ValueGroupReferencePagePicker
            dataPendo={dataPendo}
            pageRangeState={pageRangeState}
            referenceTypeState={referenceTypeState}
            page={reference.originalPage}
            docPageCount={intake.pages}
            showReferenceType
            pageRangeSX={{ left: 55, top: 0 }}
            hideReferenceLabel
          />
        )}
      </Box>
      <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          data-pendo={`${dataPendo}-updated`}
          disabled={!referenceUpdated}
          onClick={() => onUpdate()}
          size="small"
          variant="contained">
          Update
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button data-pendo={`${dataPendo}-delete`} size="small" variant="text" onClick={() => onDelete(reference.id)}>
          Delete
        </Button>
      </CardActions>
    </Card>
  );
}
